import { NumberInput, ReferenceInput, SelectInput, minValue, required } from "react-admin";
import { integerValidator } from "utils/validations";
import { useMaxSemester } from "../CurriculumContext";
import {
  CreditsInput,
  GridItem,
  HoursInput,
  InstructionLanguageInput,
  NationalityInput,
  SemesterInput,
} from "./Partials";

const ScheduledItemFields = ({ source, reference, label }) => {
  const maxSemester = useMaxSemester();

  return (
    <>
      <GridItem md={12}>
        <ReferenceInput
          source={source}
          reference={reference}
          perPage={1000}
        >
          <SelectInput
            optionText="name"
            label={label}
            fullWidth
            validate={required("Полето е задължително.")}
          />
        </ReferenceInput>
      </GridItem>

      <NationalityInput isRequired />
      <SemesterInput max={maxSemester} />

      <InstructionLanguageInput />
      <CreditsInput />

      <HoursInput
        source="auditoriumOccupancy"
        label="Часове аудиторна заетост"
        md={4}
      />
      <HoursInput
        source="practicalExercisesPerSemester"
        label="Часове на семестър"
        md={4}
      />
      <GridItem md={4}>
        <NumberInput
          source="durationInCalendarDays"
          label="Продължителност в календарни дни"
          fullWidth
          min={0}
          step={1}
          validate={[required("Полето е задължително."), minValue(0, "Минималната стойност е 0."), integerValidator]}
          onWheel={e => e.target.blur()}
        />
      </GridItem>
    </>
  );
};

export default ScheduledItemFields;
